module.exports = __webpack_public_path__ + "static/media/Heneritta Bullard Wardrobes (14).0de840f4.jpg";